<template>
  <mdb-icon
    v-if="direct"
    color="success"
    icon="check"
    title="Direct flight"
  />
</template>

<script>
import { mdbIcon } from 'mdbvue'

export default {
  name: 'CalcFlightsTableCellDirect',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    direct () {
      return !this.row.via
    }
  },
  components: {
    mdbIcon
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcFlightsTableCellDirect.vue